export const ssr = false;
export const prerender = false;

import { PUBLIC_FLURPLE_APP_URL } from '$env/static/public';
import { fetchClientNotifications } from '$lib/stores/client-notifications.store';
import { flowApi } from '$lib/api/flow.api';
import { deleteCookie, getCookie } from '$lib/helpers/session';

import type { User } from '$lib/interfaces/interfaces';
import type { HttpError } from '@sveltejs/kit';

export async function load({ fetch }) {
  // Banners apply to users and prospects alike, so load them before the
  // user-only branch below and let them resolve alongside the user info call.
  const notificationsPromise = fetchClientNotifications(fetch);

  if (!getCookie('token')) return { notifications: await notificationsPromise };

  try {
    const userInfoResponse = await flowApi.investors.userInfo();
    const userInfo: User = await userInfoResponse.json();

    return { userInfo, notifications: await notificationsPromise };
  } catch (error) {
    if ((error as HttpError).status === 401) {
      deleteCookie('token');
      window.location.href = `${PUBLIC_FLURPLE_APP_URL}/login?redirectUrl=${window.location.href}`;
    } else if ((error as HttpError).status === 403 && getCookie('impersonation_token')) {
      // Stale impersonation session (expired, revoked or superseded) — drop it
      // and continue with the user's own session instead of logging them out
      deleteCookie('impersonation_token');
      deleteCookie('impersonation_original_url');
      window.location.reload();
    } else {
      throw 'An unexpected error occurred when trying to get user information';
    }
  }
}
